import { useAuth0 } from '@auth0/auth0-react';
import posthog from 'posthog-js';

export const useLogout = () => {
  const { logout } = useAuth0();

  return () => {
    posthog.reset();
    logout({ logoutParams: { returnTo: `${window.location.origin}/login` } });
  };
};
